const state = {
  deviceType: 'unknown',
  osName: 'unknown',
  manufacturer: 'unknown'
}

const getters = {
  isMobile: state => state.deviceType === 'mobile',
  isAndroid: state => state.osName === 'android'
}

const actions = {}

const mutations = {
  SET_USER_AGENT(state, userAgent) {
    if (/Windows/i.test(userAgent)) {
      state.osName = 'windows'
      state.manufacturer = 'microsoft'
    } else if (/iPhone|iPad|iPod|Mac/i.test(userAgent)) {
      state.osName = 'mac/ios'
      state.manufacturer = 'apple'
    } else if (/Android/i.test(userAgent)) {
      state.osName = 'android'
      state.manufacturer = 'google'
    } else if (/X11|Linux/i.test(userAgent)) {
      state.osName = 'unix'
      state.manufacturer = 'unix'
    }

    state.deviceType = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) ? 'mobile' : 'desktop'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
